import React, { useState, useCallback } from 'react'
import { Grid, Card } from '@mui/material'
import {
  SimpleForm,
  TextInput,
  Confirm,
  useGetOne,
  useUpdate,
  useNotify,
  useRefresh,
} from 'react-admin'
import { MyAutocompleteInput } from '../../components/domains/blog-news-section/AutoCompleteinput'
import { NewsBlogSelectInput } from '../../components/domains/blog-news-section/NewsBlogSelectinput'
import { NewsBlogSection } from './type'
import { FormBottomToolbarWithPermission } from '../../components/form'
import { isYoutubeLink } from '../../utils/validators'

const NewsBlogSectionEdit = (): JSX.Element => {
  const [updateData, setUpdateData] = useState({} as NewsBlogSection)
  const [slot1type, setslot1Type] = useState('')
  const [slot2type, setslot2Type] = useState('')
  const [slot3type, setslot3Type] = useState('')
  const { data: newsBlogData, isLoading: newsLoading } = useGetOne('news-blog-section', { id: '' })
  const [open, setOpen] = useState(false)
  const refresh = useRefresh()
  const notify = useNotify()
  const handleDialogClose = (): void => setOpen(false)

  const onSuccess = useCallback(async (): Promise<void> => {
    notify('update success', { type: 'success' })
    refresh()
  }, [notify, refresh])

  const onError = useCallback(
    (error): void => {
      const errorMessage = error.response.data.message
      return notify(errorMessage || 'update failed', { type: 'error' })
    },
    [notify],
  )

  const [update, { isLoading }] = useUpdate(undefined, undefined, { onError, onSuccess })

  const handleConfirm = useCallback(async (): Promise<void> => {
    await update('news-blog-section', {
      id: newsBlogData.id,
      // data: { encType: 'multipart/form-data', ...updateData },
      data: {
        ...updateData,
      },
    })
    handleDialogClose()
  }, [update, updateData, newsBlogData])

  if (newsLoading) return null

  const handleSubmit = (data): void => {
    const { ...newsblogdata } = data
    newsblogdata.id = newsBlogData?.id
    setUpdateData(newsblogdata as NewsBlogSection)
    setOpen(true)
  }

  const typeChoices = [
    // { id: 'news', name: 'News' },
    // { id: 'blogs', name: 'Blog' },
    { id: 'news', name: 'ข่าว' },
    { id: 'blogs', name: 'บทความ' },
  ]
  const putDefaultValue = (): object => ({
    id: newsBlogData?.id || '',
    youtube_link: newsBlogData?.youtube_link || '',
    slot1: newsBlogData?.slot1?.id || '',
    slot2: newsBlogData?.slot2?.id || '',
    slot3: newsBlogData?.slot3?.id || '',
  })

  const slot1handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedType = e.target.value
    setslot1Type(selectedType)
  }
  const slot2handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedType = e.target.value
    setslot2Type(selectedType)
  }
  const slot3handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedType = e.target.value
    setslot3Type(selectedType)
  }
  return (
    <Card>
      <SimpleForm
        onSubmit={handleSubmit}
        toolbar={
          <FormBottomToolbarWithPermission showDeleteButton={false} backgroundColor='#fff' />
        }
        // toolbar={<ApproveAndPublishToolBar encType='multipart/form-data' />}
        defaultValues={putDefaultValue}
      >
        <Confirm
          isOpen={open}
          loading={isLoading}
          title='Update News and Blog'
          content='Are you sure you want to update ?'
          onConfirm={handleConfirm}
          onClose={handleDialogClose}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} order={{ xs: -1, sm: 0 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextInput
                  // sx={{ display: 'none' }}
                  source='youtube_link'
                  fullWidth
                  validate={[isYoutubeLink()]}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <NewsBlogSelectInput
                  source='slot1_content_type'
                  choices={typeChoices}
                  label='ประเภทคอนเทนต์'
                  fullWidth
                  onChange={slot1handleChange}
                  defaultValue={newsBlogData?.slot1?.content_type || ''}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MyAutocompleteInput
                  source='slot1'
                  type={
                    slot1type == '' || undefined ? newsBlogData?.slot1?.content_type : slot1type
                  }
                  disable={slot1type === ''}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <NewsBlogSelectInput
                  source='slot2_content_type'
                  choices={typeChoices}
                  label='ประเภทคอนเทนต์'
                  fullWidth
                  onChange={slot2handleChange}
                  defaultValue={newsBlogData?.slot2?.content_type || ''}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MyAutocompleteInput
                  source='slot2'
                  type={
                    slot2type == '' || undefined ? newsBlogData?.slot2?.content_type : slot2type
                  }
                  disable={slot2type === ''}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <NewsBlogSelectInput
                  source='slot3_content_type'
                  choices={typeChoices}
                  label='ประเภทคอนเทนต์'
                  fullWidth
                  onChange={slot3handleChange}
                  defaultValue={newsBlogData?.slot3?.content_type || ''}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MyAutocompleteInput
                  source='slot3'
                  type={
                    slot3type == '' || undefined ? newsBlogData?.slot3?.content_type : slot3type
                  }
                  disable={slot3type === ''}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </Card>
  )
}

export default NewsBlogSectionEdit
